import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';

import styles from './Products.module.scss';
import LinkButton from '../../components/linkButton';

const cx = classNames.bind(styles);

const Products = ({ data }) => {
  const navigate = useNavigate();

  const moveToDetail = (uri) => {
    navigate(uri);
  };

  return (
    <ul className={cx('container')}>
      {data.map((product, index) => (
        <li key={index} className={cx(product.title)}>
          <p className={cx('line')}>{product.line}</p>
          <h3 className={cx('name')}>{product.name}</h3>
          <img
            src={product.openImage}
            alt={product.title}
            draggable={false}
            className={cx('openImage')}
            onClick={() => moveToDetail(product.uri)}
          />
          <img src={product.closeImage} alt={product.title} draggable={false} className={cx('closeImage')} />
          <p className={cx('title')}>{product.title}</p>
          <LinkButton title="SHOP NOW" link="https://smartstore.naver.com/levrai_cosmetic" color={product.title} />
        </li>
      ))}
    </ul>
  );
};

export default Products;
